export function formatSizeUnits(bytes) {
  const size = bytes / 1048576
  return size.toFixed(2)
}